<div class="container mt-4 monitor-list-shell">
  <div class="monitor-list-toolbar">
    <div class="monitor-list-heading">
      <h4 class="monitor-list-title">
        <i class="fa fa-id-badge" aria-hidden="true"></i>
        Moniteurs
      </h4>
      @if (monitors) {
        <span class="monitor-list-count">
          {{ filteredMonitors().length }} moniteur{{ filteredMonitors().length > 1 ? 's' : '' }}
        </span>
      }
    </div>

    <div class="monitor-list-actions">
      <div class="monitor-filter" role="group" aria-label="Filtrer par statut">
        <button type="button" [class.active]="statusFilter === 'ACTIVE'" (click)="statusFilter = 'ACTIVE'">
          Actifs <span>{{ countByStatus('ACTIVE') }}</span>
        </button>
        <button type="button" [class.active]="statusFilter === 'DISABLED'" (click)="statusFilter = 'DISABLED'">
          Désactivés <span>{{ countByStatus('DISABLED') }}</span>
        </button>
        <button type="button" [class.active]="statusFilter === 'ALL'" (click)="statusFilter = 'ALL'">
          Tous <span>{{ countByStatus('ALL') }}</span>
        </button>
      </div>

      <div class="monitor-list-search">
        <i class="fa fa-search monitor-list-search-icon" aria-hidden="true"></i>
        <input type="search" class="form-control" placeholder="Rechercher un moniteur"
          aria-label="Rechercher un moniteur" [value]="searchTerm"
          (input)="searchTerm = $any($event.target).value">
      </div>
    </div>
  </div>

  @if (errorMessage) {
    <div class="alert alert-danger alert-dismissible" role="alert">
      {{ errorMessage }}
      <button type="button" class="close" aria-label="Fermer" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  }

  <div class="monitor-table-card">
    @if (!monitors) {
      <div class="monitor-loading">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Chargement des moniteurs…
      </div>
    }

    @if (monitors && filteredMonitors().length > 0) {
      <table class="table monitor-table">
        <thead>
          <tr>
            <th scope="col">Moniteur</th>
            <th scope="col" class="monitor-col-phone">Téléphone</th>
            <th scope="col" class="monitor-col-email">Email</th>
            <th scope="col" class="monitor-col-status">Statut</th>
            <th scope="col" class="monitor-col-arrow"><span class="visually-hidden">Ouvrir</span></th>
          </tr>
        </thead>
        <tbody>
          @for (m of filteredMonitors(); track m) {
            <tr tabindex="0"
              [ngClass]="{'monitor-disabled': isDisabled(m)}"
              (click)="consultMonitor(m.id)" (keydown.enter)="consultMonitor(m.id)">
              <td class="monitor-cell-identity">
                <span class="monitor-avatar"
                  [style.background]="m.color || '#e0ecff'"
                [style.color]="m.color ? '#ffffff' : '#1d4ed8'">{{ initials(m) }}</span>
                <span class="monitor-name">{{ m.lastname | uppercase }} {{ m.firstname }}</span>
              </td>
              <td class="monitor-col-phone">
                @if (m.phoneNumber) {
                  <a [href]="'tel:' + m.phoneNumber"
                  (click)="$event.stopPropagation()">{{ m.phoneNumber }}</a>
                } @else {
                  <span class="monitor-empty-value">—</span>
                }
              </td>
              <td class="monitor-col-email">
                @if (m.email) {
                  <a [href]="'mailto:' + m.email"
                  (click)="$event.stopPropagation()">{{ m.email }}</a>
                } @else {
                  <span class="monitor-empty-value">—</span>
                }
              </td>
              <td class="monitor-col-status">
                @if (isAbsentMonitor(m)) {
                  <span class="monitor-badge badge-absent">Absence</span>
                }
                @if (!isAbsentMonitor(m) && m.enabled === false) {
                  <span class="monitor-badge badge-disabled">Désactivé</span>
                }
                @if (!isAbsentMonitor(m) && m.enabled !== false) {
                  <span class="monitor-badge badge-active">Actif</span>
                }
                @if (canToggle(m)) {
                  <button type="button" class="monitor-toggle"
                    [class.to-enable]="isDisabled(m)" [disabled]="togglingId === m.id"
                    [attr.aria-label]="(isDisabled(m) ? 'Activer ' : 'Désactiver ') + m.firstname + ' ' + m.lastname"
                    (click)="toggleEnabled(m, $event)" (keydown.enter)="$event.stopPropagation()">
                    @if (togglingId === m.id) {
                      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    }
                    @if (togglingId !== m.id) {
                      <i class="fa" [ngClass]="isDisabled(m) ? 'fa-toggle-off' : 'fa-toggle-on'" aria-hidden="true"></i>
                    }
                    {{ isDisabled(m) ? 'Activer' : 'Désactiver' }}
                  </button>
                }
              </td>
              <td class="monitor-col-arrow"><i class="fa fa-chevron-right" aria-hidden="true"></i></td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (monitors && filteredMonitors().length === 0) {
      <div class="monitor-empty">
        <i class="fa fa-user-o" aria-hidden="true"></i>
        <p>{{ searchTerm ? 'Aucun moniteur ne correspond à « ' + searchTerm + ' ».'
        : (statusFilter === 'DISABLED' ? 'Aucun moniteur désactivé.' : 'Aucun moniteur pour le moment.') }}</p>
      </div>
    }
  </div>

</div>
